import { useGet } from '../api/useGet';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetTranslations, Translation } from '../../api/dtos';


const request = () =>  new GetTranslations();

const getData = (response?: SWRResponse<Translation[], Translation[]>) => response?.data;
const getError = (response?: SWRResponse<Translation[], Translation[]>) => ((response?.error ?? response?.data) as any)?.responseStatus;

export const useTranslations = (configuration?: SWRConfiguration) => {

    return useGet(request, { getData, getError}, configuration);
};

export default useTranslations;
